import {AuthenticatorConfigResponse, AuthenticatorValidationStatus} from "@/types/autenticationresult";
import {Store} from "vuex";
import BrowsersettingsService from "@/services/TwoFactorAuth/browsersettings.service";
import ResponseData from "@/types/ResponseData";
import APIDataServices from "@/services/APIDataServices";
// import {sessionStorageTwoFactorTokenVariable} from "@/types/constants";

class APPTwoFactorAuthenticationService {

    // reset2FACache() {
    //   this.resetTwoFactorAuthenticationProcess();
    //   this.resetTwoFactorUserBlockedDate();
    //   this.setTwoFactorSetupResponse(null);
    // }
    //
    // public getAuthenticatorConfiguration(userid: number) {
    //   return APITwoFactorAuthenticationService.getAuthenticatorConfiguration(userid);
    // }
    //
    // public setAuthenticatorConfiguration(userid: number, enable: boolean, deviceid: string) {
    //   const item = BrowsersettingsService.getsessionStorageTokenVariable() as string;
    //   const itemparsed = JSON.parse(item) as AuthenticationResult;
    //   return APITwoFactorAuthenticationService.setAuthenticatorConfiguration(userid, enable, deviceid, itemparsed.token);
    // }
    //
    //
    // public setAuthenticatorValidate(twoFactorToken: string, code: string) {
    //   return APITwoFactorAuthenticationService.setAuthenticatorValidate(twoFactorToken, code);
    // }
    //
    setTwoFactorAuthenticationProcessWizard(forward: boolean, store: Store<any>) {
        const currentStep = store.getters.getTwoFactorAuthStep;
        const newstep = forward ? currentStep + 1 : currentStep - 1;
        const nextStep
            = AuthenticatorValidationStatus[AuthenticatorValidationStatus[newstep] as keyof typeof AuthenticatorValidationStatus];
        store.commit("setTwoFactorAuthStep", nextStep);
    }

    startTwoFactorAuthenticationProcess(store: Store<any>) {
        store.commit("setTwoFactorAuthStep", AuthenticatorValidationStatus.Info2FA);
    }

    setAuthenticatorConfiguration(enable: boolean, store: Store<any>) {
        const deviceid = BrowsersettingsService.getLocalStorageTwoFactorUUIDVariable();
        const tokenISM = store.getters.getISMToken;
        if (tokenISM && deviceid) {
            APIDataServices
                .setAuthenticatorConfiguration(enable, deviceid, tokenISM)
                .then((response: ResponseData) => {
                    // console.log('result config 2FA: ' + JSON.stringify(response));
                    const TwoFactorAuthConfig = response.data as AuthenticatorConfigResponse;
                    if (TwoFactorAuthConfig) {
                        store.commit("setTwoFactorAuthToken", TwoFactorAuthConfig.twoFactorToken);

                        const securityEnabled = TwoFactorAuthConfig.isTwoFactorEnabled;
                        // const TwoFactorEnabled = TwoFactorAuthConfig.isTwoFactorEnabled;
                        const twoFactorToken = TwoFactorAuthConfig.twoFactorToken ? TwoFactorAuthConfig.twoFactorToken : '';
                        if (securityEnabled) {
                            // BrowsersettingsService.setSessionStoragePropertyValue(sessionStorageTwoFactorTokenVariable, twoFactorToken);
                            store.commit("setTwoFactorAuthToken", twoFactorToken);
                            this.startTwoFactorAuthenticationProcess(store);
                        } else {
                            store.commit("resetTwoFactorAuth");
                        }
                    }
                });
        }
    }

    //
    // resetTwoFactorAuthenticationProcess() {
    //   this.setTwoFactorAuthenticationProcess(AuthenticatorValidationStatus.None);
    // }
    //
    setTwoFactorAuthenticationProcess(status: AuthenticatorValidationStatus, store: Store<any>) {
        store.commit("setTwoFactorAuthStep", status);
    }
    //
    // setTwoFactorSetupResponse(response: AuthenticatorSetupResponse) {
    //   this.TwoFactorSetupResponse = response;
    // }
    //
    // getTwoFactorSetupResponse() {
    //   return this.TwoFactorSetupResponse;
    // }
    //
    setTwoFactorUserBlockedDate(date: string, store: Store<any>) {
      store.commit("setTwoFactorUserBlockedDate", date);
    }
    resetTwoFactorUserBlockedDate(store: Store<any>) {
      store.commit("setTwoFactorUserBlockedDate", '');
    }
    //
    // getTwoFactorUserBlockedDate() {
    //   return this.TwoFactorUserBlockedDate;
    // }
    //
    // // setTwoFactorUserEmail(email: string) {
    // //   this.TwoFactorUserEmail = email;
    // // }
    // //
    // // getTwoFactorUserEmail() {
    // //   return this.TwoFactorUserEmail
    // // }
}

export default new APPTwoFactorAuthenticationService();
